import { toEntity, toList, toPage, queryString } from './helpers';
/**
 * Clase que implementa una API sencilla readonly para modelos con id numerico
 */
export class ReadOnlyRestApi {
    constructor(http, baseUrl, config = {}) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.config = config;
    }
    getAll() {
        if (!this.config.list)
            throw new Error('Listado completo no soportado, usar paginacion');
        return this.http.get(this.baseUrl + '/all').then(toList());
    }
    getPage(pagination) {
        if (!this.config.pagination)
            throw new Error('Paginacion no soportada');
        return this.http.get(this.baseUrl + queryString(pagination)).then(toPage(this.config.mapper));
    }
    getOne(id) {
        return this.http.get(`${this.baseUrl}/${id}`).then(toEntity(this.config.mapper));
    }
}
/**
 * Clase que implementa una API sencilla para modelos con id numerico
 */
export class RestApi extends ReadOnlyRestApi {
    constructor(http, baseUrl, config = {}) {
        super(http, baseUrl, config);
    }
    create(item) {
        return this.http.post(this.baseUrl, item).then(toEntity(this.config.mapper));
    }
    update(item) {
        return this.http.put(`${this.baseUrl}/${item.id}`, item).then(toEntity(this.config.mapper));
    }
    delete(item) {
        if ((!this.config.delete))
            throw new Error('Borrado no soportado');
        return this.http.delete(`${this.baseUrl}/${item.id}`).then(() => { });
    }
}
//# sourceMappingURL=Api.js.map